import Reveal from "@/components/feature/Reveal";

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-100/60 rounded-2xl -z-10 translate-x-4 translate-y-4" />
              <img
                src="https://readdy.ai/api/search-image?query=Editorial_photograph_of_a_refined_hospitality_scene_a_chef_hands_plating_an_elegant_dish_on_a_ceramic_plate_soft_natural_window_light_warm_cream_linen_tablecloth_terracotta_and_gold_tones_shallow_depth_of_field_premium_hospitality_magazine_photography_sophisticated_intimate_atmosphere&width=900&height=1100&seq=rjb4-about-01&orientation=portrait"
                alt="Refined hospitality dining experience"
                title="RJB4 Restaurant Group hospitality"
                className="w-full h-full object-cover object-top rounded-lg"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-primary-600 font-medium">
              About RJB4
            </p>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight tracking-tight">
              Building Exceptional Hospitality Experiences
            </h2>
            <div className="mt-6 space-y-5 text-foreground-600 text-base md:text-lg leading-relaxed font-light">
              <p>
                RJB4 Restaurant Group, LLC is a California-based restaurant and hospitality
                company dedicated to the successful operation and development of restaurant
                businesses. Our approach is grounded in thoughtful hospitality, operational
                excellence, and a commitment to creating memorable experiences for guests.
              </p>
              <p>
                From day-to-day operations to the details that shape the guest experience, we
                believe successful hospitality is built through consistency, care, and
                attention to detail.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}